import '.s{position:relative;}.ssr-plugin'
import '.a0{border-radius:50%;}.ssr-plugin'
import '.ea{box-sizing:border-box;}.ssr-plugin'
import '.ba{user-select:none;}.ssr-plugin'
import '.eb{flex-shrink:0;}.ssr-plugin'
import '.u{position:absolute;}.ssr-plugin'
import '.ec{opacity:0.2;}.ssr-plugin'
import '.ed{z-index:9;}.ssr-plugin'
import '.ee{animation:rotate 15s linear infinite;}.ssr-plugin'
import '.c{justify-content:center;}.ssr-plugin'
import '.d{align-items:center;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.t{height:100%;}.ssr-plugin'
import { Color, colors } from '../../tokens/colors.js'
import { radius } from '../../utils/radius.js'
import { Text } from '../Text/index.js'
import { styled, Style } from 'inlines'

export type AvatarProps = {
  src?: string
  disabled?: boolean
  color?: Color
  size?: 'regular' | 'small'
  label?: string
  spotlight?: boolean
  style?: Style
}

export const Avatar = ({
  src,
  color,
  disabled,
  spotlight = false,
  size = 'regular',
  label,
  style,
}: AvatarProps) => {
  const isSmall = size === 'small'
  if (!src && label) {
    if (isSmall) {
      label = label[0]
    } else if (label.includes(' ')) {
      const [a, b] = label.split(' ')
      label = a[0] + b[0]
    } else {
      label = label.substring(0, 2)
    }
  }

  const width = isSmall ? 24 : 32
  const isInverted = color === 'neutralInverted100'
  const bgColor = isInverted
    ? colors.neutralInverted100
    : (colors as any)[color]
  const borderColor = bgColor

  return (
    <styled.div className="s a0 ea ba eb"
      style={{
        backgroundColor: colors.neutralInverted80,
        border: spotlight
          ? `2px solid transparent`
          : borderColor && `2px solid ${borderColor}`,
        padding: borderColor && 2,
        width: width,
        height: width,
        ...style,
      }}
    >
      {disabled && (
        <span className="u a0 ec ed"
          style={{
            top: -2,
            right: -2,
            bottom: -2,
            left: -2,
            width: width,
            height: width,
            backgroundColor: colors.neutralInverted100,}}
        />
      )}
      {spotlight && (
        <span className="u a0 ee ed"
          style={{
            top: -2,
            right: -2,
            bottom: -2,
            left: -2,
            width: width,
            height: width,
            border: borderColor && `2px dashed ${borderColor}`,}}
        />
      )}

      {src ? (
        <img
          src={src}
          draggable={false}
          style={{
            borderRadius: radius.full,
            objectFit: 'cover',
            width: '100%',
            maxWidth: width,
            height: '100%',
            border: !color && `1px solid ${colors.neutral20Adjusted}`,
          }}
        />
      ) : (
        <div className="c d a t"
          style={{
            backgroundColor: bgColor || colors.neutral20Adjusted,
            borderRadius: radius.full,
            border: !color && `1px solid ${colors.neutral20Adjusted}`,
          }}
        >
          {label && (
            <Text
              variant="subtext-bold"
              color={
                color
                  ? isInverted
                    ? 'neutral100'
                    : 'neutralInverted100'
                  : 'neutral100'
              }
            >
              {label.toUpperCase()}
            </Text>
          )}
        </div>
      )}
    </styled.div>
  )
}
